import { PancakeTheme } from '@pancakeswap/uikit'
import { createGlobalStyle } from 'styled-components'

declare module 'styled-components' {
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`

  * {
    font-family: 'Circular', sans-serif;
    color: #F6F6F6
    /* font-family: 'Kanit', sans-serif; */
  }
  

  html {
    scroll-behavior: smooth;
    --scrollbarBG: #cfd8dc40;
    --thumbBG: #2e3342ac;
    color: #F6F6F6
  }

  *::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  * {
    scrollbar-width: thin;
    scrollbar-color: var(--thumbBG);
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *:hover::-webkit-scrollbar-thumb {
    background-color: var(--thumbBG) ;
    border-radius: 6px;
    border: none;
  }
  *::-webkit-scrollbar-corner {
    background: rgba(0,0,0,0);
  }

  body {
    background-color: #090D17;
    background: #090D17;
    color: #F6F6F6

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #__next {
    position: relative;
    z-index: 1;
  }

  #portal-root {
    position: relative;
    z-index: 2;
  }

  .vndc-table-transactions {
    .rdt_TableHeadRow {
      border-bottom: 1px solid #2b32477f !important;
      // border-top: 1px solid #2B3247 !important;
      min-height: fit-content;
      padding: 12px 0;
    }
    .rdt_TableRow {
      border-bottom: 1px solid #2b32477f !important;
    }
    .rdt_TableCol_Sortable {
      color: #464F5F !important;
    }
  }

  .skeleton {
    animation: skeleton-loading 1s linear infinite alternate;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: #36445A;
    }
    100% {
      background-color: #66748A;
    }
  }

  .pagination-table {
    ul {
      display: flex;
      list-style-type: none;
      font-size: 14px;
      line-height: 23px;
      li {
        list-style-type: none;
        padding: 0 10px;
        color: #F6F6F6;
      }
      .selected {
        color: #66748A;
      }
      .previous, .next  {
        color: #F6F6F6;
        a[aria-disabled="true"] {
          cursor: not-allowed;
          color: #66748A;
        }

      }
    }
  }
  #binanceW3W-qrcode-modal {
    color: #090D17 !important;
    div {
      color: #090D17 !important;
      div {
        span {
          color: #090D17 !important;
        }
      }

    }
  }

  #binanceW3W-qrcode-modal > div > div:first-child  {
      svg {
        path {
          fill: #66748A !important; 
        }
      }
    
  }
  .chartContainer  {
    width: 100% !important;
    display: flex;
    justify-content: center;
    /* max-width: 400px !important; */
    /* @media screen and (min-width: 1300px) {
    } */
  }


  /*  */


.div-onus-content {
  font-family: 'Circular', sans-serif;
  width: 100%;
  color: #192231;
  max-width: 1440px;
  color: #F6F6F6;

  @media screen and (max-width: 1440px) {
    @apply px-5
  }
}

.box-resolution {
  border-radius: 12px;
  background: linear-gradient(157deg, #1F2939 22.25%, rgba(31, 41, 57, 0.00) 107.48%);
  box-shadow: 0px 24px 80px 0px rgba(0, 0, 0, 0.24);
}

.box-mark {
  border-radius: 24px;
  background: #00F;
  box-shadow: 4px -4px 40px 0px rgba(0, 122, 255, 0.25);
}

.box-currency {
  border-radius: 16px;
  background: rgba(27, 34, 45, 0.50);
  box-shadow: 15px 10px 40px 0px rgba(0, 0, 0, 0.40);
}

.ellipse1 {
  width: 260px;
  height: 260px;
  border-radius: 260px;
  background: linear-gradient(299deg, rgba(116, 124, 143, 0.25) 8.76%, rgba(9, 13, 23, 0.50) 89.33%);
  backdrop-filter: blur(18.526588439941406px);

  @media screen and (max-width: 768px) {
    width: 145px;
    height: 145px;
    border-radius: 145px;
  }
}

.ellipse2 {
  width: 260px;
  height: 260px;
  border-radius: 260px;
  background: linear-gradient(225deg, rgba(129, 144, 166, 0.20) 18.82%, rgba(38, 51, 72, 0.20) 87.81%), linear-gradient(240deg, rgba(186, 193, 209, 0.22) -53.56%, rgba(4, 10, 24, 0.50) 105.53%);
  background-blend-mode: overlay, normal;
  backdrop-filter: blur(7.5px);

  @media screen and (max-width: 768px) {
    width: 145px;
    height: 145px;
    border-radius: 145px;
  }
}

.text-ellipsis {
  color: #FFF;
  text-align: center;
  font-variant-numeric: lining-nums tabular-nums;
  text-shadow: 5px 5px 0px rgba(0, 0, 0, 0.50);
  font-family: SVN-Circular;
  font-size: 64.976px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: -0.65px;
}

.box-for-what {
  margin-bottom: 24px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(27, 34, 45, 0.50) 0%, rgba(27, 34, 45, 0.20) 114.55%);

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
    background: linear-gradient(180deg, rgba(27, 34, 45, 0.50) 0%, rgba(27, 34, 45, 0.20) 114.55%);
    padding: 24px 12px;
  }
}

.box-linear-gradient {
  padding: 60px 0px;
  background: linear-gradient(157deg, #1F2939 22.25%, #111723 107.48%);
}

.segment-linear-gradient {
  border-radius: 100px;
  background: linear-gradient(157deg, #1F2939 22.25%, rgba(31, 41, 57, 0.00) 107.48%);

  @media screen and (max-width: 768px) {
    // background: linear-gradient(157deg, #1F2939 22.25%, rgba(31, 41, 57, 0.00) 107.48%);
    background: #404449
  }
}

.mint-vndc {
  background: linear-gradient(157deg, #1F2939 22.25%, rgba(31, 41, 57, 0.00) 107.48%);
}
`

export default GlobalStyle
